import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { Selector, State } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { zone }: Boundaries["retrieveGanttCalendarRange"]["request"],
): State {
  const index = state.findIndex(
    (req) =>
      (typeof req.zone === "undefined" && typeof zone === "undefined") ||
      req.zone?.uuid === zone?.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          zone,
          range: ["", ""],
          request: setRequestStateToPending(),
        },
      ];
}

function handleSuccess(
  state: State,
  { zone, range }: Boundaries["retrieveGanttCalendarRange"]["success"],
): State {
  const index = state.findIndex(
    (req) =>
      (typeof req.zone === "undefined" && typeof zone === "undefined") ||
      req.zone?.uuid === zone?.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], range, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          zone,
          range,
          request: setRequestStateToSuccess(),
        },
      ];
}

function handleFailure(
  state: State,
  { zone }: Boundaries["retrieveGanttCalendarRange"]["failure"],
): State {
  const index = state.findIndex(
    (req) =>
      (typeof req.zone === "undefined" && typeof zone === "undefined") ||
      req.zone?.uuid === zone?.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          zone,
          range: ["", ""],
          request: setRequestStateToFailure(),
        },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveGanttCalendarRangeRequested]: handleRequest,
    [events.retrieveGanttCalendarRangeSucceeded]: handleSuccess,
    [events.retrieveGanttCalendarRangeFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
